/* SHILEX · Pop-up global de ENVÍO EXPRÉS GRATIS — contador evergreen 2 días.
   Auto-contenido: inyecta su CSS + HTML, trigger por tiempo/scroll, 1 vez por sesión,
   mobile-first, accesible (focus-trap, ESC), reduce-motion. */
(function () {
  if (window.__clxPop) return; window.__clxPop = 1;
  try { if (sessionStorage.getItem('clxPopShown') === '1') return; } catch (e) {}
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  var CSS = '\
  .clxpop-ov{position:fixed;inset:0;z-index:99990;display:flex;align-items:center;justify-content:center;padding:18px;\
    background:rgba(23,16,14,.5);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);opacity:0;transition:opacity .4s ease;pointer-events:none}\
  .clxpop-ov.is-on{opacity:1;pointer-events:auto}\
  .clxpop{position:relative;width:100%;max-width:380px;background:linear-gradient(180deg,#fff,#FBF8F4);border:1px solid rgba(200,168,107,.5);\
    border-radius:20px;padding:34px 26px 28px;text-align:center;box-shadow:0 30px 70px -24px rgba(23,16,14,.55);\
    transform:translateY(16px) scale(.96);opacity:0;transition:transform .5s cubic-bezier(.2,.9,.3,1),opacity .5s ease;font-family:"Montserrat",sans-serif}\
  .clxpop-ov.is-on .clxpop{transform:none;opacity:1}\
  .clxpop__x{position:absolute;top:12px;right:12px;width:34px;height:34px;border:0;background:transparent;color:#17100E;opacity:.5;cursor:pointer;font-size:22px;line-height:1;border-radius:50%;transition:opacity .2s,background .2s}\
  .clxpop__x:hover{opacity:1;background:rgba(23,16,14,.06)}\
  .clxpop__eye{display:inline-block;font-size:.66rem;letter-spacing:.22em;text-transform:uppercase;font-weight:700;color:#890f00;margin-bottom:10px}\
  .clxpop__t{font-family:"Playfair Display",serif;font-weight:800;line-height:1.02;font-size:clamp(1.9rem,8vw,2.4rem);color:#17100E;margin:0}\
  .clxpop__t em{font-style:italic;color:#890f00}\
  .clxpop__p{margin:12px auto 0;max-width:26ch;font-size:.9rem;line-height:1.55;color:#5b5048}\
  .clxpop__p s{color:#a99;text-decoration-thickness:1.5px}\
  .clxpop__p b{color:#17100E;font-weight:700}\
  .clxpop__clock{display:flex;gap:7px;justify-content:center;margin:18px 0 4px}\
  .clxpop__seg{min-width:54px;background:#17100E;color:#FBF8F4;border-radius:12px;padding:9px 4px 7px}\
  .clxpop__seg b{display:block;font-family:"Playfair Display",serif;font-weight:700;font-size:1.5rem;line-height:1;font-variant-numeric:tabular-nums}\
  .clxpop__seg span{display:block;font-size:.52rem;letter-spacing:.12em;text-transform:uppercase;color:rgba(251,248,244,.6);margin-top:5px}\
  .clxpop__sep{align-self:center;font-weight:700;color:#C8A86B}\
  .clxpop__cta{margin-top:18px;display:inline-flex;align-items:center;justify-content:center;width:100%;padding:15px 20px;background:#890f00;color:#FBF8F4;\
    border:0;border-radius:999px;font-weight:700;font-size:.95rem;letter-spacing:.02em;cursor:pointer;box-shadow:0 12px 26px -12px rgba(137,15,0,.6);transition:transform .25s,box-shadow .25s}\
  .clxpop__cta:hover{transform:translateY(-2px);box-shadow:0 18px 32px -12px rgba(137,15,0,.7)}\
  .clxpop__fine{margin-top:11px;font-size:.66rem;letter-spacing:.04em;color:#9a8f86}\
  @media (prefers-reduced-motion:reduce){.clxpop-ov,.clxpop{transition:none}}';

  var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s);

  var ov = document.createElement('div');
  ov.className = 'clxpop-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Oferta de envío exprés');
  ov.innerHTML = '\
    <div class="clxpop">\
      <button class="clxpop__x" type="button" aria-label="Cerrar">&times;</button>\
      <span class="clxpop__eye">Solo por tiempo limitado</span>\
      <h2 class="clxpop__t">Envío exprés <em>gratis</em></h2>\
      <p class="clxpop__p">Antes <s>$150</s> — <b>hoy gratis</b>. Te llega en <b>3 a 7 días</b> a todo México.</p>\
      <div class="clxpop__clock" aria-hidden="true">\
        <div class="clxpop__seg"><b data-d>00</b><span>días</span></div>\
        <div class="clxpop__sep">:</div>\
        <div class="clxpop__seg"><b data-h>00</b><span>hrs</span></div>\
        <div class="clxpop__sep">:</div>\
        <div class="clxpop__seg"><b data-m>00</b><span>min</span></div>\
        <div class="clxpop__sep">:</div>\
        <div class="clxpop__seg"><b data-s>00</b><span>seg</span></div>\
      </div>\
      <button class="clxpop__cta" type="button">Quiero aprovecharlo</button>\
      <div class="clxpop__fine">Aplica en todos los pedidos · sin código</div>\
    </div>';

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var elD = ov.querySelector('[data-d]'), elH = ov.querySelector('[data-h]'), elM = ov.querySelector('[data-m]'), elS = ov.querySelector('[data-s]');
  var tick;
  function refresh() {
    var cycle = 48 * 3600;                          // 2 días (evergreen): cuenta a 0 y reinicia solo
    var rem = cycle - (Math.floor(Date.now() / 1000) % cycle);
    elD.textContent = pad(Math.floor(rem / 86400));
    elH.textContent = pad(Math.floor(rem % 86400 / 3600));
    elM.textContent = pad(Math.floor(rem % 3600 / 60));
    elS.textContent = pad(rem % 60);
  }

  var lastFocus;
  function open() {
    try { if (sessionStorage.getItem('clxPopShown') === '1') return; sessionStorage.setItem('clxPopShown', '1'); } catch (e) {}
    document.body.appendChild(ov);
    refresh(); tick = setInterval(refresh, 1000);
    requestAnimationFrame(function () { ov.classList.add('is-on'); });
    lastFocus = document.activeElement;
    ov.querySelector('.clxpop__x').focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    ov.classList.remove('is-on');
    clearInterval(tick);
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 420);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
  ov.querySelector('.clxpop__x').addEventListener('click', close);
  ov.querySelector('.clxpop__cta').addEventListener('click', close);

  /* trigger óptimo: lo primero entre ~13s, scroll 45%, o exit-intent (desktop). 1 vez por sesión. */
  var armed = true;
  function fire() { if (!armed) return; armed = false; cleanup(); open(); }
  function onScroll() {
    var h = document.documentElement; var sc = (h.scrollTop || document.body.scrollTop);
    var max = (h.scrollHeight - h.clientHeight) || 1;
    if (sc / max >= 0.45) fire();
  }
  function onExit(e) { if (e.clientY <= 0) fire(); }
  function cleanup() {
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
    clearTimeout(timer);
  }
  var timer = setTimeout(fire, 13000);
  window.addEventListener('scroll', onScroll, { passive: true });
  if (!('ontouchstart' in window)) document.addEventListener('mouseout', onExit);
})();
